import { AlertBoxMsg } from '@qrios/frontend-library';

import { nortadaLogger } from '../../../../common/logger';

import { ContentHandlerProps } from './interfaces';
import { VerifyOtp, SaveSecrets, NewClientForm } from './steps';

export const creatingProfileContentHandler = ({
  activeStepNumber,
  goToNextStep,
  onFailure,
  msisdn,
  shortcode
}: ContentHandlerProps) => {
  switch (activeStepNumber) {
    case 0:
      return <NewClientForm goToNextStep={goToNextStep} onFailure={onFailure} />;
    case 1:
      return <VerifyOtp goToNextStep={goToNextStep} onFailure={onFailure} msisdn={msisdn} shortcode={shortcode} />;
    case 2:
      return <SaveSecrets />;
    default:
      nortadaLogger.critical('Unknown step in "Creating a new client profile" view.');
      return <AlertBoxMsg severity="error">Ups! Something goes wrong!</AlertBoxMsg>;
  }
};
